document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('hypeReelsModal');
    if (!modal) return;

    const modalVideo = document.getElementById('hypeReelsModalVideo');
    const closeBtn = modal.querySelector('.hype-reels-modal__close');
    const overlay = modal.querySelector('.hype-reels-modal__overlay');
    const reelItems = document.querySelectorAll('.hype-reels__item');
    const productVideos = document.querySelectorAll('.hype-product-card__video[data-video-url]');
    const reelsSections = document.querySelectorAll('.hype-reels-section');

    const openModal = (videoUrl) => {
        if (!videoUrl) return;

        modalVideo.src = videoUrl;
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        modalVideo.play();
    };

    const closeModal = () => {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        modalVideo.pause();
        modalVideo.src = '';
    };

    const attachOpenHandlers = (elements) => {
        elements.forEach(el => {
            const handler = (e) => {
                if (e && e.target && e.target.closest && e.target.closest('.hype-reels__product-card')) {
                    return;
                }
                const videoUrl = el.getAttribute('data-video-url');
                openModal(videoUrl);
            };

            el.addEventListener('click', handler);
            el.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    if (e.target && e.target.closest && e.target.closest('.hype-reels__product-card')) {
                        return;
                    }
                    e.preventDefault();
                    handler(e);
                }
            });
        });
    };

    attachOpenHandlers(reelItems);
    attachOpenHandlers(productVideos);

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
            closeModal();
        }
    });

    reelsSections.forEach((section) => {
        const grid = section.querySelector('.hype-reels__grid');
        const nextBtn = section.querySelector('.hype-reels__scroll-next');

        if (!grid || !nextBtn) return;

        const getScrollAmount = () => {
            const firstCard = grid.querySelector('.hype-reels__item');
            if (!firstCard) return 300;
            const styles = window.getComputedStyle(grid);
            const gap = parseFloat(styles.columnGap || styles.gap) || 16;
            return firstCard.offsetWidth + gap;
        };

        const updateNextButton = () => {
            const nearEnd = Math.ceil(grid.scrollLeft + grid.clientWidth) >= grid.scrollWidth;
            nextBtn.disabled = nearEnd;
        };

        nextBtn.addEventListener('click', () => {
            grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });

        grid.addEventListener('scroll', updateNextButton, { passive: true });
        window.addEventListener('resize', updateNextButton);
        updateNextButton();
    });
});
